import application from 'stimulus_application';
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./gallery-overlay.scss";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
